import { render, staticRenderFns } from "./IconFinder.vue?vue&type=template&id=a5fb1838"
import script from "./IconFinder.vue?vue&type=script&lang=js"
export * from "./IconFinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports